import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { KnowledgeDeliveryEvents } from 'lib-knowledge-types';
import { authManager } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';
import { ampli } from 'lib-shared-tracking';
import { Suspense, useMemo } from 'react';

import { useNotifications } from 'hooks/useNotifications';

import { KnowledgeErrorPlaceholder } from './components/errorPlaceholder';
import { KnowledgeLoading } from './components/loading/knowledgeLoading';
import { RemoteKnowledgeDeliveryRoutes } from './components/remotes';

export const KnowledgeDeliveryRoutes = (): JSX.Element => {
  const notify = useNotifications();
  const onHandlers = useMemo(() => {
    const handlers: KnowledgeDeliveryEvents = {
      'article:viewed': (payload) => ampli.knowledgeArticleViewed(payload),
      'articles:searched-by-terms': (payload) =>
        ampli.knowledgeArticlesSearchByTermSubmitted(payload),
      'collection:viewed': (payload) =>
        ampli.knowledgeCollectionViewed(payload),
      'internalKb:dashboard-viewed': (payload) =>
        ampli.knowledgeInternalKbDashboardViewed(payload),
      'internalKb:search-result-clicked': (payload) =>
        ampli.knowledgeInternalKbSearchResultClicked(payload),
    };
    return handlers;
  }, []);

  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      <Suspense fallback={<KnowledgeLoading />}>
        <RemoteKnowledgeDeliveryRoutes
          getLock={async () => await authManager.getAuthData()}
          on={onHandlers}
          notify={notify}
          environment={config.environment}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
